import './style.scss';
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.css';

const swiper = new Swiper('.wp-block-hhb-blocks-top-slider_inner', {  // eslint-disable-line
    effect: 'fade',
    loop: true,
    slidesPerView: 1,
    speed: 600,
    autoplay: {
        delay: 4000,
    },
    pagination: {
        el: '.swiper-pagination',
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    }
});